<template>
  <div>
    <div v-if="this.$route.params.txid">
      <router-view></router-view>
    </div>
    <div v-else>
      <div>
        <order-filter
          :orderBy="[{id: null,name: 'Últimos cadastros'},{id: 'first',name: 'Mais antigos'}]"
          :listSellers="sellers"
          :transactionStep="[
              { id: null, name: 'Selecionar' },
              { id: 'ABANDONED', name: 'Abandonado' },
              { id: 'APPROVED', name: 'Aprovado - Pagamentos Pendentes' },
              { id: 'CANCELED', name: 'Cancelado' },
              { id: 'REJECTED_PURCHASE_OVER_LIMIT', name: 'Compra fora do limite' },
              { id: 'CONTRACT', name: 'Contrato' },
              { id: 'CREATED', name: 'Criado' },
              { id: 'ANALYSIS', name: 'Em Análise' },
              { id: 'FINISHED', name: 'Finalizado' },
              { id: 'WAITING_FOR_APPROVAL', name: 'Esperando Aprovação' },
              { id: 'WAITING_FOR_VERIFICATION', name: 'Esperando Validação' },
              { id: 'STARTED', name: 'Iniciado' },
              { id: 'INSTALLMENT_SELECTION', name: 'Seleção de Parcela' },
              { id: 'VERIFICATION_DOCUMENT', name: 'Verificação Documento' },
              { id: 'VERIFICATION_SELFIE', name: 'Verificação Selfie' },
              { id: 'VERIFICATION_PHONE', name: 'Verificação Telefone' },
              { id: 'REJECTED', name: 'Rejeitado' },
              { id: 'REJECTED_SPC_RESTRICTION', name: 'Restrição no SPC' },
            ]"
          @loadFilterData="getHandleFilter($event)"
        />
      </div>
      <whatsapp-customer-component
        v-if="whatsappOpen"
        :id="uuid"
        :customerName="customerName"
        :customerProfilePicture="customerProfilePicture"
        :splitMessage="splitMessage"
        :seller="seller"
        :reference="reference"
        :totalInstallments="totalInstallments"
        :nextInstallment="nextInstallment"
        @onOpen="onWhatsappOpen"
        @emitWhastappClose="emitWhastappClose"
        @emitContactOpen="emitContactOpen"
      />
      <table-component
        :class="whatsappOpen ? 'whatsapp-is-open' : ''"
        :title="'Em validação'"
        :data="validationList"
        :columns="columnsInValidation"
        :accordion="true"
        :loading="loading"
        :totalListItems="totalInValidationItems"
        :active="columnLineActive"
        @lineActive="getLineActive($event)"
        @functionOutput="getFunctionOutput($event)"
        @handleLoadMore="getHandleLoadMoreInValidation($event)"
        @emit-loading="handleLoading"
      />
      <table-component
        :class="whatsappOpen ? 'whatsapp-is-open' : ''"
        :title="'Aguardando documentação'"
        :data="awaitingDocumentationList"
        :columns="columnsAwaitingDocumentation"
        :accordion="true"
        :loading="loading"
        :totalListItems="totalAwaitingDocumentationItems"
        :active="columnLineActive"
        @lineActive="getLineActive($event)"
        @functionOutput="getFunctionOutput($event)"
        @handleLoadMore="getHandleLoadMoreAwaitingDocumentation($event)"
        @emit-loading="handleLoading"
      />
      <table-component
        :class="whatsappOpen ? 'whatsapp-is-open' : ''"
        :title="'Aguardando PIX'"
        :data="pixList"
        :columns="columnsPixList"
        :accordion="true"
        :loading="loading"
        :totalListItems="totalPixListItems"
        :active="columnLineActive"
        @lineActive="getLineActive($event)"
        @functionOutput="getFunctionOutput($event)"
        @handleLoadMore="getHandleLoadMorePix($event)"
        @emit-loading="handleLoading"
      />
      <table-component
        :class="whatsappOpen ? 'whatsapp-is-open' : ''"
        :title="'Todos'"
        :data="fetchCustomerDataList"
        :columns="columnsFetchCustomerData"
        :accordion="true"
        :loading="loading"
        :totalListItems="totalFetchCustomerDataItems"
        :active="columnLineActive"
        @lineActive="getLineActive($event)"
        @functionOutput="getFunctionOutput($event)"
        @handleLoadMore="getHandleLoadMoreFetchCustomerData($event)"
        @emit-loading="handleLoading"
      />
      <div :class="whatsappOpen ? 'whatsapp-is-open' : ''">
        <b-row>
          <b-col>
            <sms-recovery-component v-if="$auth.check('ROLE_ADMIN') || $auth.check('ROLE_SUPER')"></sms-recovery-component>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '../../partial/card/Card.vue'
import Input from '../../partial/form/Input.vue'
import OrdersList from '../../partial/order/OrdersList.vue'
import SmsRecovery from '../../partial/validations/SmsRecovery.vue'
import OrderFilter from '../../partial/order/OrderFilter'
import PixListComponent from '../../partial/pix/PixListComponent.vue'
import WhatsappCustomer from '../../partial/customer/WhatsappCustomer.vue'
import Table from './components/Table.vue'
import moment from 'moment'

export default {
  components: {
    'card-component': Card,
    'input-component': Input,
    'orders-list-component': OrdersList,
    'sms-recovery-component': SmsRecovery,
    'order-filter': OrderFilter,
    'pix-list-component': PixListComponent,
    'whatsapp-customer-component': WhatsappCustomer,
    'table-component': Table
  },
  data () {
    return {
      refreshList: null,
      currentPage: 1,
      totalFetchCustomerDataItems: 0,
      sellers: null,
      isValidationCollapse: false,
      isValidationDocumentCollapse: false,
      isValidationPix: false,
      isClosedCollapse: false,
      typeList: null,
      loading: false,

      loadMorePixList: 10,
      loadMoreInValidationList: 10,
      loadMoreAwaitingDocumentationList: 10,
      loadMoreFetchCustomerDataList: 10,

      uuid: null,

      whatsappOpen: false,
      whatsappScrollbar: false,
      customerName: null,
      customerProfilePicture: null,
      splitMessage: null,
      seller: null,
      reference: null,
      totalInstallments: null,
      totalPixListItems: null,
      totalInValidationItems: null,
      totalAwaitingDocumentationItems: null,
      totalFetchValidationDataItems: null,
      nextInstallment: null,
      columnLineActive: null,

      nameFilterLoad: '',
      sellerFilterLoad: null,
      serviceStatusFilterLoad: false,
      orderListFilterLoad: null,
      stepListFilterLoad: null,
      dateFilterLoad: null,
      validations: true,
      timer: null,

      scrollY: 0,
      whatsappHeightMobile: 0,

      data: [],
      dataPix: [],
      dataInValidation: [],
      dataAwaitingDocumentation: [],
      dataFetchCustomerData: [],
      dataLine: [],
      validationList: [],
      awaitingDocumentationList: [],
      fetchCustomerDataList: [],
      pixList: [],

      columnsPixList: [
        {
          header: '',
          field: 'id',
          dataType: 'id',
          style: 'width: 9%',
          class: 'primary-color',
          rating: false,
          link: true,
          linkName: 'OrderValidation',
          linkParams: 'uuid'
        },
        {
          header: 'Data',
          field: 'dateCreated',
          dataType: 'date',
          style: 'width: 11%;',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Cliente',
          field: 'buyerName',
          dataType: 'text',
          style: 'width: 18%; font-weight: 600;',
          class: '',
          rating: true,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Email',
          field: 'buyerEmail',
          dataType: 'text',
          style: 'width: 14%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Telefone',
          field: 'buyerPhone',
          dataType: 'phone',
          style: 'width: 12%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Loja',
          field: 'sellerName',
          dataType: 'text',
          style: 'width: 10%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Status',
          field: 'installment.status',
          dataType: 'tag',
          style: 'width: 20%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: '',
          field: 'uuid',
          dataType: 'button',
          style: 'width: 3%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        }
      ],

      columnsInValidation: [
        {
          header: '',
          field: 'id',
          dataType: 'id',
          style: 'width: 9%',
          class: 'primary-color',
          rating: false,
          link: true,
          linkName: 'OrderValidation',
          linkParams: 'uuid'
        },
        {
          header: 'Data',
          field: 'dateCreated',
          dataType: 'date',
          style: 'width: 11%;',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Cliente',
          field: 'buyerName',
          dataType: 'text',
          style: 'width: 18%; font-weight: 600;',
          class: '',
          rating: true,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Email',
          field: 'buyerEmail',
          dataType: 'text',
          style: 'width: 14%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Telefone',
          field: 'buyerPhone',
          dataType: 'phone',
          style: 'width: 12%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Loja',
          field: 'sellerName',
          dataType: 'text',
          style: 'width: 10%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Status',
          field: 'installment.status',
          dataType: 'tag',
          style: 'width: 20%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: '',
          field: 'uuid',
          dataType: 'button',
          style: 'width: 3%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        }
      ],

      columnsAwaitingDocumentation: [
        {
          header: '',
          field: 'id',
          dataType: 'id',
          style: 'width: 9%',
          class: 'primary-color',
          rating: false,
          link: true,
          linkName: 'OrderValidation',
          linkParams: 'uuid'
        },
        {
          header: 'Data',
          field: 'dateCreated',
          dataType: 'date',
          style: 'width: 11%;',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Cliente',
          field: 'buyerName',
          dataType: 'text',
          style: 'width: 18%; font-weight: 600;',
          class: '',
          rating: true,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Email',
          field: 'buyerEmail',
          dataType: 'text',
          style: 'width: 14%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Telefone',
          field: 'buyerPhone',
          dataType: 'phone',
          style: 'width: 12%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Loja',
          field: 'sellerName',
          dataType: 'text',
          style: 'width: 10%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Status',
          field: 'installment.status',
          dataType: 'tag',
          style: 'width: 20%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: '',
          field: 'uuid',
          dataType: 'button',
          style: 'width: 3%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        }
      ],

      columnsFetchCustomerData: [
        {
          header: '',
          field: 'id',
          dataType: 'id',
          style: 'width: 9%',
          class: 'primary-color',
          rating: false,
          link: true,
          linkName: 'OrderValidation',
          linkParams: 'uuid'
        },
        {
          header: 'Data',
          field: 'dateCreated',
          dataType: 'date',
          style: 'width: 11%;',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Cliente',
          field: 'buyerName',
          dataType: 'text',
          style: 'width: 18%; font-weight: 600;',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Email',
          field: 'buyerEmail',
          dataType: 'text',
          style: 'width: 14%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Telefone',
          field: 'buyerPhone',
          dataType: 'phone',
          style: 'width: 12%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Loja',
          field: 'sellerName',
          dataType: 'text',
          style: 'width: 10%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: 'Status',
          field: 'installment.status',
          dataType: 'tag',
          style: 'width: 20%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        },
        {
          header: '',
          field: 'uuid',
          dataType: 'button',
          style: 'width: 3%',
          class: '',
          rating: false,
          link: false,
          linkName: '',
          linkParams: ''
        }
      ]
    }
  },
  // methods: {
  //   changeCollapsePix () {
  //     this.isValidationPix = !this.isValidationPix
  //   },
  //   changeCollapseName () {
  //     this.isValidationCollapse = !this.isValidationCollapse
  //   },
  //   changeValidationDocumentCollapse () {
  //     this.isValidationDocumentCollapse = !this.isValidationDocumentCollapse
  //   },
  //   changeClosedCollapse () {
  //     this.isClosedCollapse = !this.isClosedCollapse
  //   },
  //   getSellers () {
  //     this.$http
  //       .get('api/selects/sellers')
  //       .then(function (res) {
  //         this.sellers = res.data.list
  //         this.sellers.splice(0, 0, { id: null, name: 'Selecionar' })
  //       })
  //       .catch(function (res) {
  //         console.log('Error')
  //         console.log(res)
  //       })
  //   }
  // },
  mounted () {
    this.timer = setInterval(() => {
      this.refreshList = !this.refreshList
    }, 15000)
    window.addEventListener('scroll', () => {
      this.scrollPosition()
    })

    this.$root.$on('openCollapseValidation', (step) => {
      let el = document.getElementById('collapseValidation')
      if (step !== null) {
        el.classList.remove('show')
        this.isValidationCollapse = false
      } else {
        el.classList.add('show')
        this.isValidationCollapse = true
      }
    })

    this.$root.$on('openCollapseValidationDocument', (step) => {
      let el = document.getElementById('collapseValidationDocument')
      if (step !== null) {
        el.classList.remove('show')
        this.isValidationDocumentCollapse = false
      } else {
        el.classList.add('show')
        this.isValidationDocumentCollapse = true
      }
    })

    this.$root.$on('openCollapsePix', () => {
      let el = document.getElementById('collapseValidationPix')
      el.className = 'show'
      this.isValidationPix = true
    })

    this.orderListFilterLoad = 'first'
    this.getPixList()
    this.getInValidation()
    this.getAwaitingDocumentation()
    this.getFetchCustomerData()
    this.getSellers()
  },
  methods: {
    handleLoading () {
      this.loading = true
    },
    getWhatsappOpen () {
      this.whatsappOpen = true
    },
    getUuid (event) {
      this.uuid = event
    },
    getCustomerName (event) {
      this.customerName = event
    },
    getCustomerProfilePicture (event) {
      this.customerProfilePicture = event
    },
    getSeller (event) {
      this.seller = event
    },
    getReference (event) {
      this.reference = event
    },
    getHandleFilter (payload) {
      this.nameFilterLoad = payload.name
      this.sellerFilterLoad = payload.seller
      this.stepListFilterLoad = payload.transactionStepSelected
      this.orderListFilterLoad = payload.orderBySelected
      this.dataFilterLoad = payload.date

      this.refreshList = (this.refreshList === null) ? true : !this.refreshList
    },
    getFunctionOutput (event) {
      this.dataLine = event
      this.whatsappOpen = true
      this.uuid = this.dataLine.uuid
      this.customerName = this.dataLine.buyerName
      this.customerProfilePicture = this.dataLine.profilePicture
      this.seller = this.dataLine.sellerName
    },
    getHandleLoadMorePix (event) {
      this.loadMorePixList += event[0]
      this.loading = event[1]
      this.getPixList()
    },
    getHandleLoadMoreInValidation (event) {
      this.loadMoreInValidationList += event[0]
      this.loading = event[1]
      this.getInValidation()
    },
    getHandleLoadMoreAwaitingDocumentation (event) {
      this.loadMoreAwaitingDocumentationList += event[0]
      this.loading = event[1]
      this.getAwaitingDocumentation()
    },
    getHandleLoadMoreFetchCustomerData (event) {
      this.loadMoreFetchCustomerDataList += event[0]
      this.loading = event[1]
      this.getFetchCustomerData()
    },
    async getPixList (val) {
      let dataInicial = null
      let dataFinal = null
      let nameValue = ''

      if (this.nameFilterLoad) {
        nameValue = this.removeDots(this.nameFilterLoad)
      }

      if (this.dataFilterLoad) {
        dataInicial = moment(this.dataFilterLoad.start).format('YYYY-MM-DD')
        dataFinal = moment(this.dataFilterLoad.end).format('YYYY-MM-DD')
      }

      // await this.$http.get('api/validations/pix-validations-list',
      await this.$http.get('api/validations/pix-validations-list')
        .then(function (res) {
          // console.log('=======================================')
          // console.log('name ' + nameValue)
          // console.log('order ' + this.orderListFilterLoad)
          // console.log('step ' + this.stepListFilterLoad)
          // console.log('serviceStatus ' + this.serviceStatusFilterLoad)
          // console.log('seller ' + this.sellerFilterLoad)
          // console.log('startdate ' + dataInicial)
          // console.log('enddate ' + dataFinal)

          let stepOpt = [
            { id: 'ABANDONED', name: 'Abandonado' },
            { id: 'APPROVED', name: 'Aprovado - Pagamentos Pendentes' },
            { id: 'CANCELED', name: 'Cancelado' },
            { id: 'REJECTED_PURCHASE_OVER_LIMIT', name: 'Compra fora do limite' },
            { id: 'CONTRACT', name: 'Contrato' },
            { id: 'CREATED', name: 'Criado' },
            { id: 'ANALYSIS', name: 'Em Análise' },
            { id: 'FINISHED', name: 'Finalizado' },
            { id: 'WAITING_FOR_APPROVAL', name: 'Esperando Aprovação' },
            { id: 'WAITING_FOR_VERIFICATION', name: 'Esperando Validação' },
            { id: 'STARTED', name: 'Iniciado' },
            { id: 'INSTALLMENT_SELECTION', name: 'Seleção de Parcela' },
            { id: 'VERIFICATION_DOCUMENT', name: 'Verificação Documento' },
            { id: 'VERIFICATION_SELFIE', name: 'Verificação Selfie' },
            { id: 'VERIFICATION_PHONE', name: 'Verificação Telefone' },
            { id: 'REJECTED', name: 'Rejeitado' },
            { id: 'REJECTED_SPC_RESTRICTION', name: 'Restrição no SPC' }
          ]

          let data = res.data

          if (this.sellerFilterLoad !== null) {
            data.list = data.list.filter((arr) => { return arr.sellerId === this.sellerFilterLoad })
          }

          if (this.stepListFilterLoad !== null) {
            stepOpt = stepOpt.filter((arr) => { return arr.id === this.stepListFilterLoad })[0]
            console.log(stepOpt.name)
            data.list = data.list.filter((arr) => { return arr.currentStep === stepOpt.name })
          }

          if (this.orderListFilterLoad === null) {
            data.list = data.list.sort((a, b) => { return new Date(b.dateCreated) - new Date(a.dateCreated) })
          }

          if (nameValue) {
            data.list = data.list.filter((arr) => { return arr.buyerName.toLowerCase().includes(nameValue.toLowerCase()) || arr.buyerEmail.toLowerCase().includes(nameValue.toLowerCase()) || arr.buyerPhone.toLowerCase().includes(nameValue.toLowerCase()) || arr.buyerCpf.toLowerCase().includes(nameValue.toLowerCase()) || arr.reference.toLowerCase().includes(nameValue.toLowerCase()) })
          }

          if (dataInicial !== null && dataFinal !== null) {
            data.list = data.list.filter((arr) => { return moment(moment(arr.dateCreated).format('YYYY-MM-DD')).isSameOrAfter(dataInicial) && moment(moment(arr.dateCreated).format('YYYY-MM-DD')).isSameOrBefore(dataFinal) })
          }

          data.total = data.list.length
          data.list = data.list.slice(0, this.loadMorePixList)

          // console.log(data.list)
          this.dataPix = data
          this.pixList = data.list
          this.totalPixListItems = data.total
          this.loading = false
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
          this.loading = false
        })
    },
    async getInValidation (val) {
      let page = val || this.currentPage
      let dataInicial = null
      let dataFinal = null
      let nameValue = ''

      if (this.nameFilterLoad) {
        nameValue = this.removeDots(this.nameFilterLoad)
      }

      if (this.dataFilterLoad) {
        dataInicial = moment(this.dataFilterLoad.start).format('YYYY-MM-DD')
        dataFinal = moment(this.dataFilterLoad.end).format('YYYY-MM-DD')
      }

      await this.$http
        .get('api/validations', {
          params: {
            offset: this.loadMoreInValidationList * (page - 1),
            max: this.loadMoreInValidationList,
            name: nameValue,
            order: this.orderListFilterLoad,
            validations: true,
            step: this.stepListFilterLoad === 'WAITING_FOR_APPROVAL' || this.stepListFilterLoad === null ? 'WAITING_FOR_APPROVAL' : 'null',
            serviceStatus: this.serviceStatusFilterLoad,
            seller: this.sellerFilterLoad,
            startdate: dataInicial,
            enddate: dataFinal
          }
        })
        .then(function (res) {
          console.log(res)
          this.dataInValidation = res.data
          this.validationList = this.dataInValidation.list.reverse()
          this.totalInValidationItems = res.data.total
          this.loading = false
        })
        .catch(function (res) {
          this.dataInValidation = []
          this.validationList = []
          this.totalInValidationItems = null
          console.error('Error')
          console.error(res)
          this.loading = false
        })
    },
    async getAwaitingDocumentation (val) {
      let page = val || this.currentPage
      let dataInicial = null
      let dataFinal = null
      let nameValue = ''

      if (this.nameFilterLoad) {
        nameValue = this.removeDots(this.nameFilterLoad)
      }

      if (this.dataFilterLoad) {
        dataInicial = moment(this.dataFilterLoad.start).format('YYYY-MM-DD')
        dataFinal = moment(this.dataFilterLoad.end).format('YYYY-MM-DD')
      }

      await this.$http
        .get('api/validations', {
          params: {
            offset: this.loadMoreAwaitingDocumentationList * (page - 1),
            max: this.loadMoreAwaitingDocumentationList,
            name: nameValue,
            order: this.orderListFilterLoad,
            validations: false,
            step: this.stepListFilterLoad === 'WAITING_FOR_VERIFICATION' || this.stepListFilterLoad === null ? 'WAITING_FOR_VERIFICATION' : 'null',
            serviceStatus: this.serviceStatusFilterLoad,
            seller: this.sellerFilterLoad,
            startdate: dataInicial,
            enddate: dataFinal
          }
        })
        .then(function (res) {
          this.dataAwaitingDocumentation = res.data
          this.awaitingDocumentationList = this.dataAwaitingDocumentation.list.reverse()
          this.totalAwaitingDocumentationItems = res.data.total
          this.loading = false
        })
        .catch(function (res) {
          this.dataAwaitingDocumentation = []
          this.awaitingDocumentationList = []
          this.totalAwaitingDocumentationItems = null
          console.error('Error')
          console.error(res)
          this.loading = false
        })
    },
    async getFetchCustomerData (val) {
      let page = val || this.currentPage
      let dataInicial = null
      let dataFinal = null
      let nameValue = ''

      if (this.nameFilterLoad) {
        nameValue = this.removeDots(this.nameFilterLoad)
      }

      if (this.dataFilterLoad) {
        dataInicial = moment(this.dataFilterLoad.start).format('YYYY-MM-DD')
        dataFinal = moment(this.dataFilterLoad.end).format('YYYY-MM-DD')
      }

      await this.$http
        .get('api/customerservice', {
          params: {
            offset: this.loadMoreFetchCustomerDataList * (page - 1),
            max: this.loadMoreFetchCustomerDataList,
            name: nameValue,
            order: this.orderListFilterLoad,
            validations: false,
            step: this.stepListFilterLoad,
            serviceStatus: this.serviceStatusFilterLoad,
            seller: this.sellerFilterLoad,
            startdate: dataInicial,
            enddate: dataFinal
          }
        })
        .then(function (res) {
          this.dataFetchCustomerData = res.data
          this.fetchCustomerDataList = res.data.list.reverse()
          this.totalFetchCustomerDataItems = res.data.total
          this.loading = false
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
          this.loading = false
        })
    },
    getLineActive (event) {
      this.columnLineActive = event
    },
    emitWhastappClose () {
      this.whatsappOpen = false
      this.columnLineActive = null
    },
    emitContactOpen () {
      this.approveOpen = false
      this.whatsappOpen = false
    },
    onWhatsappOpen () {
      this.scrollPosition()
    },
    async getCustomerInstallments (uuid) {
      this.loading = true
      await this.$http.get('api/order-validation/' + uuid + '/customer-installments')
        .then(function (res) {
          res.data.map(obj => {
            this.data.push({
              installment: obj.installment,
              dueDate: obj.dueDate,
              amount: obj.amount,
              status: obj.status,
              paymentType: obj.paymentType,
              boletosPage: `https://meu.boletoflex.com/#/${this.$route.params.txid}`
            })

            if (obj.status === 'Pendente' || obj.status === 'Paga') {
              this.totalInstallments += 1
            }
          })

          for (let i = 0; i < res.data.length; i++) {
            const nextInstallment = res.data[i]
            if (nextInstallment.status === 'Pendente') {
              this.nextInstallment = nextInstallment
              break
            }
          }

          this.$emit('emit-next-installment', this.nextInstallment)
          this.$emit('emit-total-installments', this.totalInstallments)
          this.loading = false
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
          this.loading = false
        })
    },
    changeCollapsePix () {
      this.isValidationPix = !this.isValidationPix
    },
    changeCollapseName () {
      this.isValidationCollapse = !this.isValidationCollapse
    },
    changeValidationDocumentCollapse () {
      this.isValidationDocumentCollapse = !this.isValidationDocumentCollapse
    },
    changeClosedCollapse () {
      this.isClosedCollapse = !this.isClosedCollapse
    },
    async getSellers () {
      await this.$http
        .get('api/selects/sellers')
        .then(function (res) {
          console.log(res)
          this.sellers = res.data.list
          this.sellers.splice(0, 0, { id: null, name: 'Selecionar' })
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
        })
    },
    removeDots: function (name) {
      return name.replace(/\.|-|\(|\) |\)/g, '')
    },
    scrollPosition () {
      this.scrollY = window.pageYOffset
      this.whatsappScroll()
    },
    whatsappScroll () {
      const whatsapp = document.getElementById('whatsapp')
      if (whatsapp) {
        if (this.scrollY >= 152) {
          whatsapp.classList.add('whatsapp-scroll')
        } else {
          if (document.getElementById('whatsapp')) {
            whatsapp.classList.remove('whatsapp-scroll')
          }
        }
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
  watch: {
    'refreshList' () {
      this.getPixList()
      this.getInValidation()
      this.getAwaitingDocumentation()
      this.getFetchCustomerData()
    }
  }
}

</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variaveis.scss";
  @import "../../../assets/scss/card.scss";

  .whatsapp-is-open {
    width: 70%;
    float: left;
  }

  .card {
    border: none;
    border-radius: 16px;
  }

  .bf-order-collapse {
    color: #007bff;
    display: flex;
    justify-content: space-between;

    span {
      color: #8EB0FF;
    }

    button {
      background-color: #E3ECFF;
      border-color: #E3ECFF;
      outline-color: #E3ECFF;
    }

    .bf-arrow {
      transform: rotate(180deg)
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/order/OrderList.vue